module.exports = __webpack_public_path__ + "static/diseño-23dded3ad4964d287c4aaa45a715ca44.jpg";